import AssistantRagStorageDialog from '@shared/components/AssistantRagStorageDialog';
import type { IAssistantRagStorageDialogProps } from '@shared/components/AssistantRagStorageDialog';

import { usePreventGameKeydownListening } from '@hooks';

type Props = IAssistantRagStorageDialogProps;

const AssistantContextDialogWrapper = (props: Props) => {
  const paperRef = usePreventGameKeydownListening<HTMLDivElement>();

  return (
    <AssistantRagStorageDialog
      {...props}
      paperRef={paperRef}
      modalTheme="light"
    />
  );
};

export default AssistantContextDialogWrapper;
